"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Supplier_1 = require("./Supplier");
var Sync_1 = require("./Sync");
var SyncUtils_1 = require("../SyncUtils");
var SyncSupplier = /** @class */ (function (_super) {
    __extends(SyncSupplier, _super);
    function SyncSupplier() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sync = new Sync_1.Sync();
        _this._onLoad = function (value) {
            _this.setValue(value);
            _this.sync.syncEnd();
        };
        _this._onError = function (error) {
            _this.clearValue();
            _this.sync.syncError(error);
        };
        return _this;
    }
    SyncSupplier.prototype._loadImpl = function () {
        if (this.loader) {
            return this.loader();
        }
        return Promise.reject({ code: "NOT_IMPLEMENTED", message: "_loadImpl() not implemented" });
    };
    SyncSupplier.prototype.refresh = function () {
        if (this.sync.syncing) {
            return SyncUtils_1.toPromise(this.sync);
        }
        this.sync.syncStart({ type: "load" });
        return this._loadImpl().then(this._onLoad).catch(this._onError);
    };
    SyncSupplier.prototype.load = function () {
        if (this.sync.syncing) {
            return SyncUtils_1.toPromise(this.sync);
        }
        if (!this.sync.hasSynced || this.sync.error) {
            return this.refresh();
        }
        return Promise.resolve();
    };
    __decorate([
        mobx_1.observable
    ], SyncSupplier.prototype, "sync", void 0);
    __decorate([
        mobx_1.action
    ], SyncSupplier.prototype, "_onLoad", void 0);
    __decorate([
        mobx_1.action
    ], SyncSupplier.prototype, "_onError", void 0);
    __decorate([
        mobx_1.action
    ], SyncSupplier.prototype, "refresh", null);
    __decorate([
        mobx_1.action
    ], SyncSupplier.prototype, "load", null);
    return SyncSupplier;
}(Supplier_1.Supplier));
exports.SyncSupplier = SyncSupplier;
